import { EffectCarousel } from './theme.js';
import { animateSequence as animateSequence14 } from "vendor";
import 'ia-variant-picker';
import 'ia-product-image';
var ContentCarousel = class extends EffectCarousel {
  createOnChangeAnimationControls(fromSlide, toSlide, { direction } = {}) {
    return animateSequence14([
      [fromSlide, { visibility: ["visible", "hidden"], opacity: [1, 0], transform: ["translateY(0)", "translateY(-1em)"] }, { duration: 0.3, at: 0, ease: [0.55, 0.055, 0.675, 0.19] }],
      [toSlide, { visibility: ["hidden", "visible"], opacity: [0, 1], transform: ["translateY(1em)", "translateY(0)"] }, { duration: 0.5, at: "+0.2", ease: [0.25, 0.46, 0.45, 0.94] }]
    ]);
  }
};
if (!window.customElements.get("content-carousel")) {
  window.customElements.define("content-carousel", ContentCarousel);
}


// Cart fix gift app
document.addEventListener('fg-cart:auto-updated', () => {
  document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
});